import { render, staticRenderFns } from "./TagsSearch.vue?vue&type=template&id=2ec2702b&scoped=true&"
import script from "./TagsSearch.vue?vue&type=script&lang=js&"
export * from "./TagsSearch.vue?vue&type=script&lang=js&"
import style0 from "./TagsSearch.vue?vue&type=style&index=0&id=2ec2702b&lang=scss&scoped=true&"
import style1 from "./TagsSearch.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec2702b",
  null
  
)

export default component.exports